module.exports = __webpack_public_path__ + "static/banner.ba98d269.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Location/banner.svg
// module id = 699
// module chunks = 213534597649335